<template>
  <div class="backend">
    <PageHeader></PageHeader>
    <div class="container HomeContainer">
      <!-- FIXME通过加key防止复用，保证页面跳转 -->
      <Nav :key="$route.matched[0].name" class="nav" />

      <!-- <div class="router-view"> -->
      <!-- <router-view :key="$route.fullPath" /> -->
      <!-- 因buyerpurchase sellerquotation需要mounted中清空query -->
      <router-view class="router-view" :key="$route.path" />
      <!-- </div> -->
    </div>
    <RightSideBar></RightSideBar>
    <!-- <PageFooter></PageFooter> -->
  </div>
</template>

<script>
import PageHeader from "@/components/layout/PageHeader";
// import PageFooter from "@/components/layout/PageFooter";
import Nav from "@/components/layout/Nav.vue";
import RightSideBar from "@/components/layout/RightSideBar";

export default {
  name: "Backend",
  components: {
    PageHeader,
    // PageFooter,
    Nav,
    RightSideBar,
  },
};
</script>
<style scoped lang="scss">
.backend {
  width: 100%;
  min-height: 100vh;
  background: #f1f1f1;
  display: flex;
  flex-direction: column;
  .container {
    display: flex;
    margin-top: 10px;
    margin-bottom: 10px;
    flex-grow: 1; //用于撑开界面高度 防止不满一屏
    .nav {
      margin-right: 15px;
      min-height: 600px;
    }
    .router-view {
      width: $HomeContainerWidth - $navWidth;
      // box-sizing: border-box;
      // min-height: 600px;
      background: #fff;
    }
  }
}
</style>

